import React from 'react';
import DragDropContextProvider from '../DragDropContextProvider';
export default (function (Component) {
  var withDNDContext = function withDNDContext(props) {
    return /*#__PURE__*/React.createElement(DragDropContextProvider, null, /*#__PURE__*/React.createElement(Component, props));
  };

  withDNDContext.displayName = Component.displayName;
  return withDNDContext;
});